import VideoImport from '../../../shared/components/VideoImport';
import { CircularProgress } from '@material-ui/core';
import { BarEdition,SimpleModal } from '@orientaction/components';
import { ModalEditingEbook } from '@orientaction/components/Admin';
import clsx from 'clsx';
import Loader from '../../../../AdminGame/EditPage/loader-edit';
import ModalEditGame from '../../../../AdminGame/EditPage/modal-edit-game';
import { RedesignLayout } from '../../../shared';
import RedesignImage from '../../../shared/components/RedesignImage';
import BlockEditor from './components/BlockEditor';
import BlockToolbar from './components/BlockToolbar';
import EditSidebar from './components/EditSidebar';
import { useEditEbook } from './hooks/useEditEbook';
import { useEditEbookStyles } from './index.styles';

const EditEbookRedesign = () => {
  const classes = useEditEbookStyles();
  const edit = useEditEbook();

  const selectedBlock = edit.allBlocks[edit.indexSelected];
  const showBarEdition =
    selectedBlock?.bloc_template === 1 && selectedBlock?.contentForType !== 'citation';

  return (
    <RedesignLayout isaddBackground={true} showOverFlow={true}>
      <Loader open={edit.loading} text={edit.textLoading} />

      <ModalEditGame
        open={edit.openPublish || edit.openExit}
        handleClose={() => {
          edit.setOpenPublish(false);
          edit.setOpenExit(false);
        }}
        title={edit.valuesEbooksTemplate?.title}
        message={
          edit.openPublish
            ? "Vous êtes sur le point de publier l'ebook"
            : "Êtes-vous sûr de vouloir quitter l'édition du book ?"
        }
        onCancel={() => {
          edit.setOpenPublish(false);
          edit.setOpenExit(false);
        }}
        onConfirm={() => {
          if (edit.openExit) {
            edit.setOpenExit(false);
            edit.handleConfirmExit();
          } else {
            edit.handleConfirmPublish();
          }
        }}
      />

      <SimpleModal
        open={edit.openModal}
        handleClose={() => edit.setOpenModal(false)}
        title="Information"
        message="Êtes vous sur de vouloir supprimer le bloc ?"
        textClick="Oui"
        textClose="Non"
        handleClick={edit.deleteBlock}
      />

      <div className={classes.page}>
        <BlockToolbar
          allBlocks={edit.allBlocks}
          blockSelected={edit.blockSelected}
          handleAddUpdate={edit.handleAddUpdate}
          handleChangeInput={edit.handleChangeInput}
          handleInputChange={edit.handleInputChange}
          handleMoveToPosition={edit.handleMoveToPosition}
          indexSelected={edit.indexSelected}
          moveElement={edit.moveElement}
          scrollToSection={edit.scrollToSection}
          setOpenExit={edit.setOpenExit}
          setOpenModal={edit.setOpenModal}
          setOpenPublish={edit.setOpenPublish}
          setShowMenu={edit.setShowMenu}
          showMenu={edit.showMenu}
          stateEdition={edit.stateEdition}
          addLink={edit.addLink}
          editStyleEditor={edit.editStyleEditor}
          editPosition={edit.editPosition}
          position={edit.position}
          valueInput={edit.valueInput}
          templateBlocks={edit.templateBlocks}
          selectType={edit.selectType}
          imgRef={edit.imgRef}
          handleChangeImg={edit.handleChangeImg}
          barEdition={
            showBarEdition ? (
              <BarEdition
                stateEdition={edit.stateEdition}
                editState={edit.editStyleEditor}
                handleLink={edit.addLink}
                isEbook={false}
                editPosition={edit.editPosition}
                position={edit.position}
              />
            ) : undefined
          }
        />

        <div className={classes.contentRow}>
          <EditSidebar
            allBlocks={edit.allBlocks}
            coverUrl={edit.coverUrl}
            currentTitleIndex={edit.currentTitleIndex}
            history={edit.history}
            scrollToSection={edit.scrollToSection}
            selectBlock={edit.selectBlock}
            setBlockSelected={edit.setBlockSelected}
            setCurrentTitleIndex={edit.setCurrentTitleIndex}
            setIndexSelected={edit.setIndexSelected}
            setValueInput={edit.setValueInput}
            valuesEbooksTemplate={edit.valuesEbooksTemplate}
          />

          <div ref={edit.containerRef} className={classes.canvasColumn}>
                <div className={classes.canvasInner}>
                  {edit.isNavigating && (
                    <div className={classes.navigatingOverlay}>
                      <div>
                        <div>Chargement…</div>
                        {edit.allBlocks.length > 100 && (
                          <div style={{ fontStyle: 'italic', marginTop: 4 }}>
                            Le chargement peut prendre quelques secondes
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {edit.loadingTop && (
                    <div className={classes.scrollLoader}>
                      <CircularProgress size={30} />
                    </div>
                  )}

                  {edit.renderStart === 0 && (
                    <RedesignImage
                      src={edit.coverUrl}
                      alt=""
                      loading="lazy"
                      className={classes.coverImage}
                    />
                  )}

                  {edit.allBlocks
                    ?.slice(
                      edit.renderStart,
                      Math.min(edit.renderStart + edit.WINDOW_SIZE, edit.allBlocks.length),
                    )
                    .map((block, localIndex) => {
                      const absoluteIndex = edit.renderStart + localIndex;
                      const isSelected = absoluteIndex === edit.indexSelected;

                      return (
                        <div
                          key={absoluteIndex}
                          data-block-index={absoluteIndex}
                          className={classes.blockShell}>
                          <div
                            className={classes.blockCard}
                            onClick={() => edit.selectBlock(absoluteIndex)}
                            onKeyDown={event => {
                              if (event.key === 'Enter' || event.key === ' ') {
                                edit.selectBlock(absoluteIndex);
                              }
                            }}
                            role="button"
                            tabIndex={0}>
                            <span className={classes.blockNumber}>{absoluteIndex + 1}</span>
                            <div
                              className={clsx(classes.blockContent, {
                                [classes.blockContentSelected]: isSelected,
                              })}>
                              <BlockEditor
                                block={block}
                                index={absoluteIndex}
                                allBlocks={edit.allBlocks}
                                edit={edit}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  {edit.loadingBottom && (
                    <div className={classes.scrollLoader}>
                      <CircularProgress size={30} />
                    </div>
                  )}
                </div>
              </div>
            </div>
      </div>

      <ModalEditingEbook
        open={edit.openEditImg}
        fileUrl={edit.url}
        handleClose={() => {
          edit.setOpenEditImg(false);
          edit.setDataImg({ imgLink: '', checkedLink: false });
          edit.setIndexEditImg(null);
        }}
        handleUrl={(uri: string, imageId: unknown, link: string, checkedLink: boolean) =>
          edit.handleChangeInputImg(uri, imageId, link, checkedLink)
        }
        imgHeightB={edit.imageDimensions.height as number}
        imgWidthB={edit.imageDimensions.width as number}
        imgLink={edit.dataImg.imgLink}
        checkedLink={edit.dataImg.checkedLink}
      />

      <VideoImport
        bilingual={true}
        open={edit.openDialogVideo}
        onClose={() => edit.setOpenDialogVideo(false)}
        onSubmit={edit.handleVideoImportSubmit}
      />
    </RedesignLayout>
  );
};

export default EditEbookRedesign;
